<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Usuarios</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nuevo Usuario</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre" label="Nombre Usuario"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="idrol"
                                                :items="roles"  label="Rol">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-select v-model="tipo_documento"
                                                :items="documentos"  label="Tipo Documento">
                                            </v-select>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="number" v-model="num_documento" label="Num. Documento"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="email" label="Email"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="6">
                                            <v-text-field type="password" v-model="password" label="Contraseña"></v-text-field>
                                        </v-col>

 <!--                                           <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="codigo_empresa" label="Codigo Empresa"></v-text-field>
                                        </v-col>
-->                                        
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adNombre}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="usuarios"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.usuario }}</td>
                    <td>{{ props.item.rol }}</td>
                    <td>{{ props.item.tipo_documento }}</td>
                    <td>{{ props.item.num_documento }}</td>
                    <td>{{ props.item.email }}</td>
                    <td>{{ props.item.estado }}</td>                    
                    <td>
                        <div v-if="props.item.estado = 1">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                usuarios:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action'},
                    { text: 'Nombre Usuario', value: 'nombre' },
                    { text: 'Rol', value: 'rol' },
                    { text: 'Tipo documento', value: 'tipo_documento' },
                    { text: 'Num. Documento', value: 'num_documento' , sortable: false},
                    { text: 'Email', value: 'email' },
//                    { text: 'Codigo Empresa', value: 'codigo_empresa', sortable: false },
                    { text: 'Estado', value: 'estado' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                idusuario: '',
                idrol: '',
                nombre:'',
                roles:[
                ] ,
                tipo_documento: '',
                documentos: ['DNI','RUC','PASAPORTE','CEDULA'],
                num_documento:'',
                email:'',
                password:'',
                actPassword:false,
                passwordAnt:'',
//                codigo_empresa: '',
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdUsuario:'',
                adNombre:''
         }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nuevo usuario' : 'Actualizar usuario'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
    },
    methods:
    {
		listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Usuarios/Listar',configuracion).then(function(response){
				//console.log(response);
				me.usuarios=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},
        select(){
            let me=this;
            var rolesArray= [];
			axios.get('api/Roles/Select').then(function(response){
                //console.log(response);
                rolesArray=response.data;
                rolesArray.map(function(x){
                    me.roles.push({text: x.nombre_rol, value:x.idrol});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
 			this.idusuario=item.idusuario;
			this.idrol=item.idrol;
			this.nombre=item.nombre;
			this.tipo_documento=item.tipo_documento;
			this.num_documento=item.num_documento;
			this.email=item.email;
			this.password=item.password_hash;
//            this.codigo_empresa=item.codigo_empresa;
            this.passwordAnt = item.password_hash;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
			this.idusuario="";
			this.idrol="";
			this.nombre= "";
			this.tipo_documento="";
			this.num_documento= "";
			this.email="";
            this.password= "";
            this.codigo_empresa="";
            this.passwordAnt ="";
            this.actPassword=false;
			this.editedIndex=-1;
		},


		guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
                let me=this;
                
                if(me.password != me.passwordAnt){
                    me.actPassword=true;
                }

				axios.put('api/Usuarios/Actualizar',{
                    'idusuario':me.idusuario,
 					'idrol': me.idrol,
					'nombre': me.nombre,
					'tipo_documento':me.tipo_documento,
					'num_documento':me.num_documento,
					'email':me.email,
                    'password':me.password,
                    'act_password':me.actPassword
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Usuarios/Crear',{
					'idrol': me.idrol,
					'nombre': me.nombre,
					'tipo_documento':me.tipo_documento,
					'num_documento':me.num_documento,
					'email':me.email,
					'password':me.password
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
			this.validaMensaje=[];
			if(this.nombre.length < 3 || this.nombre.length > 100){
				this.validaMensaje.push("La  debe tener mas de 3 caracteres y menos de 50 caracteres.");
            }
			if(!this.idrol){
				this.validaMensaje.push("Seleccione un Rol.");
            }
			if(!this.tipo_documento){
				this.validaMensaje.push("Seleccione un tipo de documento.");
            }
			if(!this.email){
				this.validaMensaje.push("Ingrese un Email.");
            }
			if(!this.password){
				this.validaMensaje.push("Ingrese el Password del usuario.");
            }
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adNombre = item.nombre
        this.adIdUsuario=item.idusuario;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Usuarios/Activar/'+this.adIdUsuario,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdUsuario="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Usuarios/Desactivar/'+this.adIdUsuario,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdUsuario="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>